import React, { useState } from 'react';
import Modal from '@common/modal';
import { useGetAgreeUrl, usePostProcessingConsent } from '@repository/match';

import { V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './modals.module.scss';
const cx = classnames.bind(styles);

interface ResumeSaveModalProps {
  positionSn: number;
  visible: boolean;
  onClose: () => void;
}

const ResumeSaveModal = ({ positionSn, visible, onClose }: ResumeSaveModalProps) => {
  const { mutate: fetchProcessingConsent } = usePostProcessingConsent(onClose);
  const [isCheck, setIsCheck] = useState(true);
  const { data: agreeUrlData } = useGetAgreeUrl(positionSn, visible);
  const detailUrl = V2Route.getResumeThirdpartyAgreementPage(agreeUrlData?.url ?? '');

  const onClickSave = () => {
    fetchProcessingConsent(positionSn);
  };

  const onChangeCheck = () => {
    setIsCheck(!isCheck);
  };

  return (
    <Modal visible={visible}>
      <div className={cx('layer', 'resumeSave')}>
        <a className={cx('closeBtn')} onClick={onClose} role="button">
          <span className={cx('hidden')}>close button</span>
        </a>
        <em className={cx('title')}>
          지원 취소하기 전에
          <br /> 지원서를 잡다에 저장하시겠어요?
        </em>
        <p className={cx('desc')}>
          지원서를 저장하면 다른 지원서 작성 시<br />
          불러오기를 통해 편하게 작성할 수 있어요.
        </p>
        <strong className={cx('importantDesc')}>*지금 저장하지 않은 지원서는 영구 삭제됩니다.</strong>
        <div className={cx('agreementArea')}>
          <label className={cx('label')}>
            <input
              type="checkbox"
              className={cx('input', 'hidden')}
              defaultChecked={!isCheck ? true : false}
              onClick={onChangeCheck}
            />
            <span className={cx('checkbox')} /> (필수)지원서 저장하기 서비스에 대한 개인정보 제3자 제공 동의
          </label>
          <a className={cx('agreementDetail')} role="button" target="_blank" rel="noreferrer" href={detailUrl}>
            자세히
          </a>
        </div>
        <div className={cx('btnArea')}>
          <button className={cx('btn', 'cancel')} onClick={() => onClose()}>
            아니요
          </button>
          <button className={cx('btn', 'check')} onClick={onClickSave} disabled={isCheck}>
            저장하기
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ResumeSaveModal;
